import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-between align-items-center",
  style: { borderBottom: '0.45px solid #0000001a', padding: '0.35rem 0' }
}
const _hoisted_2 = { class: "d-flex align-items-center gap-2" }
const _hoisted_3 = { class: "member-circle" }
const _hoisted_4 = { class: "member-details d-flex flex-column" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  style: {"flex-shrink":"0"}
}
const _hoisted_8 = {
  key: 0,
  class: "action-pill add-pill px-2 d-flex align-items-center gap-1"
}
const _hoisted_9 = {
  key: 1,
  class: "action-pill remove-pill px-2"
}

import { Button } from '@/components/global'
import { PlusIcon } from '@/components/svg'

import type { ListMember } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberListItem',
  props: {
    member: {},
    action: { default: 'remove' },
    loading: { type: Boolean, default: false }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const getInitials = (member: ListMember): string => {
  const first = member.firstname ?? member.firstName
  const last = member.lastname ?? member.lastName
  if (first && last) return (first[0] + last[0]).toUpperCase()
  if (member.name) {
    const parts = member.name.trim().split(/\s+/)
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase()
  }
  return member.email.slice(0, 2).toUpperCase()
}

const getDisplayName = (member: ListMember): string => {
  const first = member.firstname ?? member.firstName
  const last = member.lastname ?? member.lastName
  if (first || last) return `${first ?? ''} ${last ?? ''}`.trim()
  return member.name ?? member.email
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(getInitials(__props.member)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(getDisplayName(__props.member)), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.member.email), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Button), {
        variant: "naked",
        size: "xs",
        loading: __props.loading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('action', __props.member)))
      }, {
        default: _withCtx(() => [
          (__props.action === 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(PlusIcon), { style: {"width":"0.625rem","height":"0.625rem","flex-shrink":"0"} }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Add", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "Remove", -1)
              ]))]))
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})